import { useState, useEffect } from "react";
import HeaderSingleSite from "./HeaderSingleSite";

import { firestore } from "../firebase";
import { collectIdsAndDocs } from "../utils";
// import { Container } from "rsuite";
import { useParams, Link } from "react-router-dom";

import Loader from "./Loader";

import { Container, CssBaseline, Card } from "@mui/material";

const PageSiteSingle = () => {
  const [site, setSite] = useState("");

  const { id } = useParams();

  const siteRef = firestore.doc(`sites/${id}`);

  let unsubscribeFromSite = null;

  useEffect(() => {
    unsubscribeFromSite = siteRef.onSnapshot((snapshot) => {
      const site = collectIdsAndDocs(snapshot);
      setSite(site);
    });

    return () => {
      unsubscribeFromSite();
    };
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Container size="sm">
      <CssBaseline />

      {loading ? <Loader /> : <HeaderSingleSite {...site} />}
      {/* {site.siteStreet} */}
      {/* {site.user.email} */}
    </Container>
  );
};

export default PageSiteSingle;
